import { makeStyles } from '@material-ui/core/styles'
import { Box, CircularProgress, Typography } from '@mui/material'

const Claims = () => {
  const classes = useStyles()
  return (
    <Box className={classes.claimContainer}>
      <Box className={classes.claimHeading}>
        What amount will the insurer pay in case of a claim?
      </Box>
      <Box className={classes.claimText}>
        <Box className={classes.repairText}>
          If your car needs repair without replacing any parts (except painting
          materials), the insurer covers 100% of the claim amount.
        </Box>
        <Box className={classes.replacementText}>
          For part replacements, the insurer pays a fixed percentage of the
          cost, following IRDAI norms, which applies uniformly across all
          insurers.
        </Box>
      </Box>
      <Box className={classes.claimCoverageSection}>
        <Box className={classes.insurerHeading}>
          Here&apos;s a simpler breakdown of what the insurer will pay for
          different car components:
        </Box>
        <Box className={classes.coverages}>
          <Box className={classes.claimItem}>
            <Box>
              <Box position={'relative'} display={'inline-flex'}>
                <CircularProgress
                  size={52}
                  thickness={4}
                  variant='determinate'
                  value={100}
                  className={classes.greenLoader}
                />
                <Box className={classes.labelContainer}>
                  <Typography
                    variant='caption'
                    component='div'
                    className={classes.loaderText}
                  >
                    100%
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box>
              <Box className={classes.loaderDescription}>
                Glass components (e.g., windshield)
              </Box>
            </Box>
          </Box>
          <Box className={classes.claimItem}>
            <Box>
              <Box position={'relative'} display={'inline-flex'}>
                <CircularProgress
                  size={52}
                  thickness={4}
                  variant='determinate'
                  value={70}
                  className={classes.blueLoader}
                />
                <Box className={classes.labelContainer}>
                  <Typography
                    variant='caption'
                    component='div'
                    className={classes.loaderText}
                  >
                    70%
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box>
              <Box className={classes.loaderDescription}>Fiberglass parts</Box>
            </Box>
          </Box>
          <Box className={classes.claimItem}>
            <Box>
              <Box position={'relative'} display={'inline-flex'}>
                <CircularProgress
                  size={52}
                  thickness={4}
                  variant='determinate'
                  value={50}
                  className={classes.redLoader}
                />
                <Box className={classes.labelContainer}>
                  <Typography
                    variant='caption'
                    component='div'
                    className={classes.loaderText}
                  >
                    50%
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box>
              <Box className={classes.loaderDescription}>
                Painting materials
              </Box>
            </Box>
          </Box>
          <Box className={classes.claimItem}>
            <Box>
              <Box position={'relative'} display={'inline-flex'}>
                <CircularProgress
                  size={52}
                  thickness={4}
                  variant='determinate'
                  value={70}
                  className={classes.blueLoader}
                />
                <Box className={classes.labelContainer}>
                  <Typography
                    variant='caption'
                    component='div'
                    className={classes.loaderText}
                  >
                    70%
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box>
              <Box className={classes.loaderDescription}>
                Plastic, rubber, nylon parts & batteries
              </Box>
            </Box>
          </Box>
          <Box className={classes.claimItem}>
            <Box>
              <Box position={'relative'} display={'inline-flex'}>
                <CircularProgress
                  size={52}
                  thickness={4}
                  variant='determinate'
                  value={90}
                  className={classes.greenLoader}
                />
                <Box className={classes.labelContainer}>
                  <Typography
                    variant='caption'
                    component='div'
                    className={classes.loaderText}
                  >
                    90%
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box>
              <Box className={classes.loaderDescription}>
                Metal, wooden, and other parts
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.claimBottomText}>
        Each insurer will require a mandatory deductible payment of ₹2,000 per
        claim as a processing fee, as per IRDAI regulations. For additional
        information, please review the policy terms and conditions.
      </Box>
    </Box>
  )
}

export default Claims

const useStyles = makeStyles({
  claimContainer: {
    border: '1px solid #DADADA',
    borderRadius: '10px',
    background: '#FFFFFF',
    marginTop: '40px',
  },
  claimHeading: {
    fontFamily: 'Roboto',
    fontWeight: '500',
    fontSize: '18px',
    borderBottom: '1px solid #DADADA',
    padding: '30px',
    borderRadius: '10px',
    color: '#10A98F',
  },
  claimText: {
    padding: '30px',
  },
  claimCoverageSection: {
    background: '#F2F2F2',
    padding: '30px',
  },
  insurerHeading: {
    fontFamily: 'Roboto',
    fontWeight: '700',
    fontSize: '15px',
    padding: '0px 30px',
    lineHeight: '19.04px',
    textAlign: 'center',
    color: '#000000',
  },
  claimBottomText: {
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '16.5px',
    textAlign: 'center',
    padding: '30px',
  },
  repairText: {
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16.5px',
  },
  replacementText: {
    paddingTop: '10px',
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17.77px',
    color: '#535353',
  },
  loaderText: {
    color: '#000000',
    fontWeight: '600 !important',
  },
  loaderDescription: {
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '17.77px',
  },
  coverages: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingTop: '20px',
    gap: 30,
  },
  labelContainer: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  blueLoader: {
    color: '#4DC3E3 !important',
    borderRadius: '50%',
    rotate: '180deg',
    boxShadow: 'inset 0 0 0 5.5px #d1d1d1',
  },
  redLoader: {
    color: '#DD7E88 !important',
    borderRadius: '50%',
    rotate: '180deg',
    boxShadow: 'inset 0 0 0 5.5px #d1d1d1',
  },
  greenLoader: {
    color: '#10A98F !important',
    borderRadius: '50%',
    rotate: '180deg',
    boxShadow: 'inset 0 0 0 5.5px #d1d1d1',
  },
  claimItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    // padding: '0px 20px 10px 0px',
  },
})
